"use client";
// РУКА 2 (по Р-021). Вкладки под карточкой товара — как в макете (.tabs). Содержимое собирает страница.
import { useState, type ReactNode } from "react";

export function CardTabs({ tabs, first }: { tabs: { key: string; label: string; body: ReactNode }[]; first: string }) {
  const [on, setOn] = useState(first);
  const cur = tabs.find((t) => t.key === on) ?? tabs[0];
  return (
    <>
      <div className="tabs" role="tablist">
        {tabs.map((t) => (
          <button key={t.key} type="button" role="tab" aria-selected={t.key === cur.key} className={t.key === cur.key ? "on" : ""} onClick={() => setOn(t.key)}>
            {t.label}
          </button>
        ))}
      </div>
      <div role="tabpanel">{cur.body}</div>
    </>
  );
}
